/**
 * Created by Jan Bradac on 9.5.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.FlashMessages;

    (function (FlashMessages, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.FlashMessages, 'Factory')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Creates and displays common flash messages
         * @memberOf Lfl.FlashMessages
         */
        Lfl.FlashMessages.Factory;

        (function (Factory, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            var getNoChangesToBeSavedUrl =  "";
            var wasInitialized = false;

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * @param parameters
             * @param parameters.getNoChangesToBeSavedUrl
             * @memberOf Lfl.FlashMessages.Factory
             */
            Factory.init = function (parameters) {
                getNoChangesToBeSavedUrl = parameters.getNoChangesToBeSavedUrl;
                wasInitialized = true;
            };

            /**
             * Displays a flash message containing a notification that although the user is trying to save data there is
             * no new data to save.
             * @memberOf Lfl.FlashMessages.Factory
             */
            Factory.displayNoChangesToBeSaved = function () {
                checkIfWasInitialized();

                $.ajax({
                    url: getNoChangesToBeSavedUrl,
                    type: "get",
                    success: function (data) {
                        Lfl.FlashMessages.Displayer.display(data);
                    }
                });
            };


            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */

            function checkIfWasInitialized() {
                if(false===wasInitialized) {
                    throw "This object was not properly initialized and cannot be used in this state."
                }
            }

        }(FlashMessages.Factory = FlashMessages.Factory || {}, jQuery));
    }(Lfl.FlashMessages = Lfl.FlashMessages || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));